import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card--scene-wizard-reorder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneListItem = _resolveComponent("SceneListItem")
  const _component_draggable = _resolveComponent("draggable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    modal: true,
    class: "dialog-reorder-scene-actions",
    header: _ctx.$t('AppResource.ReorderActions')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClick: _ctx.doHideDialog,
        class: "p-button-rounded p-button-lg p-button-text p-button-secondary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.doConfirm,
        class: "p-button-rounded p-button-lg",
        autofocus: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Confirm")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_draggable, {
          tag: "div",
          list: _ctx.itemsReordered,
          class: "list-group",
          handle: ".room-object__reorder-handle",
          animation: 150,
          "item-key": "actionParams.id"
        }, {
          item: _withCtx(({ element }) => [
            _createVNode(_component_SceneListItem, {
              item: element,
              reorderable: true
            }, null, 8, ["item"])
          ]),
          _: 1
        }, 8, ["list"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}